import { DeviceFactory } from './runtime/DeviceFactory'
import { VTNrf54LMouseDevice } from './devices/mouse/nordic-nrf54l/device'
import { CH585MDevice } from './devices/keyboard/wch-ch585m/device'
import { GcomeApKeyboardDevice } from './devices/keyboard/gcome-ap/device'
import { TelinkBaseDevice } from './devices/base-dock/telink/device'
import { NordicNrf54LBaseDevice } from './devices/base-dock/nordic-nrf54l/device'
import { OHIDDevice } from './devices/keyboard/ohid/device'
import { TelinkKeyboardDevice } from './devices/keyboard/telink/device'
import { CH315Device } from './devices/keyboard/wch-ch315/device'
import { LM20RTMouseDevice } from './devices/mouse/lm20-rt'
import { Telink3228CMouseDevice } from './devices/mouse/telink-3228c/device'
import { VTCH584MouseDevice } from './devices/mouse/wch-ch584/device'

// 注册内置驱动
DeviceFactory.register('VT_nrf54L', VTNrf54LMouseDevice)
DeviceFactory.register('VT_CH584', VTCH584MouseDevice)
DeviceFactory.register('CH585M', CH585MDevice)
DeviceFactory.register('GCOME_AP', GcomeApKeyboardDevice)
DeviceFactory.register('OHID', GcomeApKeyboardDevice)
DeviceFactory.register('Telink_Base', TelinkBaseDevice)
DeviceFactory.register('VT_nrf54L_Base', NordicNrf54LBaseDevice)
DeviceFactory.register('OHID', OHIDDevice)
DeviceFactory.register('TelinkKeyboard', TelinkKeyboardDevice)
DeviceFactory.register('CH315', CH315Device)
DeviceFactory.register('LM20RT', LM20RTMouseDevice)
DeviceFactory.register('Telink3228C_Mouse', Telink3228CMouseDevice)

export * from './types/manifest'
export * from './types/config'
export * from './types/dpi'
export * from './types/keyboardLighting'
export * from './types/lighting'
export * from './types/lightingDomain'
export * from './types/color'
export * from './types/keyboardKeys'
export * as MouseKeys from './types/mouseKeys'
export * from './types/keyTravel'
export * from './types/shaftType'
export * from './types/mousePerfCfg'
export * from './types/base'
export * as KeyboardPerfCfgTypes from './types/keyboardPerCfg'
// export * from './types/keyboardPerCfg'
export * from './types/keyboardPerfCfgGcomeAp'
export * from './types/connection'
export * from './types/firmware'
export * from './types/base'
export * from './channels/Channel'
export * from './channels/ChannelRole'
export * from './channels/ChannelResolver'
export * from './channels/hid/HidChannel'
export * from './channels/hid/HidChannelDescriptor'
export * from './channels/hid/HidChannelFactory'
export * from './channels/hid/webhid/WebHidChannel'
export * from './channels/hid/nodehid/NodeHidChannel'
export * from './channels/hid/proxy/HidChannelProxy'
export * from './manifests/ManifestTypes'
export * from './manifests/ManifestNormalizer'
export * from './events/DeviceEvents'
export * from './events/ReportEvents'
export * from './events/NoticeEvents'
export * from './events/FirmwareEvents'
export * from './events/ManagerEvents'
export * from './events/BaseDockEvents'
export * from './runtime/BaseDevice'
export * from './runtime/session/DeviceSession'
export * from './runtime/session/DeviceChannelManager'
export * from './runtime/FeatureRegistry'
export * from './channels/hid/exchange/CommandExchange'
export * from './channels/hid/exchange/OutputReportPollingExchange'
export * from './channels/hid/exchange/FeatureReportExchange'
export * from './channels/hid/exchange/InputReportExchange'
export * from './chips/shared/capabilities/MemoryCapability'
export * from './chips/shared/capabilities/FirmwareCapability'
export * from './chips/shared/capabilities/ReportCapability'
export * from './chips/shared/protocols/hid-eeprom/HidEepromMemoryClient'
export * from './chips/shared/firmware/nordic/NordicH20Upgrader'
export * from './chips/shared/firmware/nordic/NordicUpdater'
export * from './chips/shared/firmware/wch/WCHUpgrader'
export * from './chips/shared/firmware/shared/FileUtil'
export * from './chips/shared/nordic/nrf54l'
export * from './features'
export * as Features from './features'
export * from './devices/mouse/nordic-nrf54l' // 导出具体设备类型供应用层使用泛型
export * from './devices/mouse/telink-3228c'
export * from './devices/keyboard/wch-ch585m'
export * from './devices/keyboard/gcome-ap'
export * from './devices/keyboard/telink'
export * from './devices/keyboard/wch-ch315'
export * from './chips/telink/feature-impls/keyboard/firmware'
export * from './chips/telink/feature-impls/keyboard/pairing'
export * from './chips/telink/feature-impls/mouse/pairing'
export * from './chips/telink/feature-impls/mouse/firmware'
export * from './chips/telink/feature-impls/base/firmware'
export * from './chips/telink/protocols/base-usb-ota'
export * from './chips/telink/protocols/keyboard-command'
export * from './chips/wch-ch315/protocols'
export * from './chips/telink/protocols/vision-ap-mouse'
export * from './devices/base-dock'
export * from './devices/base-dock/telink/device'
export * from './devices/base-dock/nordic-nrf54l/device'
export * from './manager/RapooDeviceManager'
export * from './errors/DeviceError'
export * from './utils/StringUtils'
export { DEFAULT_MACRO_MAX_LENGTH, getMacroMaxLength } from './utils/macro'
export * from './chips/gcome-ap'
// 灯效档位校验：业务层写入前需与 SDK 用同一套范围判定，避免两侧标准不一致
export {
  sanitizeLightingLevel,
  LIGHTING_LEVEL_MIN,
  LIGHTING_LEVEL_MAX,
  LIGHTING_LEVEL_DEFAULT,
} from './chips/shared/feature-impls/keyboard-lighting/lighting'
export { DeviceFactory } // 导出工厂供外部注册自定义驱动
